import { jsx as _jsx } from "react/jsx-runtime";
import { RANGE_FILTER, BUCKET_FILTER } from '@as-react/common-types';
import { capitalizeOnly, isNullOrUndefined } from '@as-react/common-utils';
import { XIcon } from '@yonderland/andes-icons';
import { Chip, Tooltip } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { FILTER_SIZE_SEPARATOR } from '../../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
export const AppliedFilterItem = ({ activeFilterItem, onToggleFilter }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const mapActiveFilterItemToSetFilterObject = (activeFilter) => activeFilter.filterType === RANGE_FILTER
        ? {
            filterOn: activeFilter.filterOn,
            filterOnName: activeFilter.filterOnName,
            filteredItems: [
                { filterKey: activeFilter.rangeMin.toString() },
                { filterKey: activeFilter.rangeMax.toString() },
            ],
            filterType: activeFilter.filterType,
            filterContentType: activeFilter.filterContentType,
            isReset: true,
        }
        : {
            filterOn: activeFilter.filterOn,
            filterOnName: activeFilter.filterOnName,
            filteredItems: [
                {
                    filterType: activeFilter.filterType,
                    filterKey: activeFilter.filterKey,
                    filterKeyName: activeFilter.filterKeyName,
                    filterOn: activeFilter.filterOn,
                    filterOnName: activeFilter.filterOnName,
                },
            ],
            filterType: activeFilter.filterType,
            filterContentType: activeFilter.filterContentType,
            queryParamKey: activeFilter.queryParamKey,
        };
    const getTextRangeValue = (value) => [activeFilterItem.filterPrefix, value.toString(), activeFilterItem.filterSuffix]
        .filter(item => !isNullOrUndefined(item))
        .join('');
    const getTextSelect = () => activeFilterItem.filterType === BUCKET_FILTER
        ? `${activeFilterItem.filterOnName}: ${capitalizeOnly(activeFilterItem.filterKeyName)}`
        : capitalizeOnly(activeFilterItem.filterKeyName.split(FILTER_SIZE_SEPARATOR)[0]);
    const getTextRange = () => t('product.filter.range', {
        name: activeFilterItem.filterOnName,
        min: getTextRangeValue(activeFilterItem.rangeMin),
        max: getTextRangeValue(activeFilterItem.rangeMax),
    });
    const getText = () => (activeFilterItem.filterType === RANGE_FILTER ? getTextRange() : getTextSelect());
    const getTitle = () => activeFilterItem.filterType === RANGE_FILTER
        ? `${activeFilterItem.filterOnName}: ${getTextRangeValue(activeFilterItem.rangeMin)} - ${getTextRangeValue(activeFilterItem.rangeMax)}`
        : `${activeFilterItem.filterOnName} - ${capitalizeOnly(activeFilterItem.filterKeyName).split(FILTER_SIZE_SEPARATOR)[0]}`;
    return (_jsx(Tooltip, { text: getTitle(), hasCloseBtn: false, children: _jsx(Chip, { onClick: () => onToggleFilter(mapActiveFilterItemToSetFilterObject(activeFilterItem)), iconRight: { source: XIcon }, rounded: true, text: getText(), testId: "applied-filter" }) }));
};
